const withBreakpointVariants = (classNames) => {
  return classNames.flatMap((className) => [className, `sm:${className}`]);
};

module.exports = withBreakpointVariants;
